import { render, staticRenderFns } from "./o-labeled-info.vue?vue&type=template&id=21ec58a6&scoped=true&"
import script from "./o-labeled-info.vue?vue&type=script&lang=js&"
export * from "./o-labeled-info.vue?vue&type=script&lang=js&"
import style0 from "./o-labeled-info.vue?vue&type=style&index=0&id=21ec58a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ec58a6",
  null
  
)

export default component.exports